import { Skeleton } from '@heroui/react';

export type DeploymentConcurrentExecutionsCellProps = {
  /** Concurrent executions the deployment is configured with. */
  actual?: number;
  /** Most concurrent executions its size allows. */
  max?: number;
};

export function DeploymentConcurrentExecutionsCell({
  actual,
  max
}: Readonly<DeploymentConcurrentExecutionsCellProps>) {
  return (
    <p className='w-[80px] text-nowrap'>
      {actual == null || max == null ? '—' : `${actual}/${max}`}
    </p>
  );
}

export function DeploymentConcurrentExecutionsCellSkeleton() {
  return (
    <div className='w-[80px]'>
      <Skeleton className='h-4 w-10 rounded' />
    </div>
  );
}
